import styled from 'styled-components/macro'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'

export const Container = styled.header`
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
`

export const Inner = styled.div`
    height: 4rem;
    width: 90%;
    max-width: var(--content-maxwidth);
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
`

export const LogoContainer = styled(Link)`
    display: flex;
    align-items: center;
`

export const LogoImgContainer = styled.span`
    display: inline-block;
    width: 3rem;
    height: 3rem;
    background-color: white;
    border-radius: 50%;
    margin-right: 1rem;
    border: 2px solid black;

    @media all and (max-width: 650px) {
        margin-right: .3rem;
    }
`

export const LogoImg = styled.img`
    width: 100%;
    height: 100%;
`

export const LogoText = styled.span`
    font-weight: bold;
    font-size: 1rem;
    color: ${({color}) => color};
`

export const SocialContainer = styled.div`
    display: flex;
    justify-content: space-evenly;
    aligin-items: center;
    width: 6rem;
`

export const SocialIcon = styled.a`
    cursor: pointer;

    svg {
        font-size: 1.5rem;
        color: ${({color}) => color}; 
    }
`